import router from './router';
import store from './store';
import { Message } from 'element-ui';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { getToken, setTid, setToken, getTid, removeExpiresState } from '@/utils/auth';
import { checkAppVersion } from '@/utils/versionCheck';

NProgress.configure({ showSpinner: false });

const whiteList = [
  '/login',
  '/supplierreg',
  '/login/index',
  '/auth-redirect',
  '/bind',
  '/register',
  '/que'
];

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.query.zdToken) {
    setToken(to.query.zdToken)
    next({ path: to.path});
  }
  if (getToken()) {
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' });
      NProgress.done();
    } else {
      if (store.getters.roles.length === 0) {
        // 判断当前用户是否已拉取完user_info信息
        const tid = to.query.tid
        const token = to.query.token
        if (tid) {
          setTid(tid)
        }
        if (token) {
          setToken(token)
        }
        // 获取帐号失效等信息
        store.dispatch('GetSystemInfo').then(() => {
          next();
        })
        store
          .dispatch('GetInfo')
          .then(() => {
            if (store.state.user.isAdmin === 1 && getTid() == undefined) {
              Message({
                message: "当前为超级管理员，租户缓存已经过期，请重新从后台选择租户id进入。",
                type: 'error',
                offset: 145,
                showClose: true,
              })
            }
            store.dispatch('GetPartner')
            store.dispatch('GetRouter')
            next();
          })
          .catch((err) => {
            store.dispatch('LogOut').then(() => {
              Message({
                message: err,
                type: 'error',
                offset: 145,
                showClose: true,
              })
              next({ path: '/' });
            }).catch(() => {
              Message({
                message: err,
                type: 'error',
                offset: 145,
                showClose: true,
              })
              next({ path: '/' });
            });
          });
      } else {
        next();
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      removeExpiresState()
      store.commit('SET_NAME', '');
      store.commit('SET_ROLES', []);
      next(`/login?redirect=${to.fullPath}`); // 否则全部重定向到登录页
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
  // 路由切换时检测是否有新版本（不阻塞跳转）
  checkAppVersion();
});
